var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dateRange-wrapper",
      class: { "has-sliders": _vm.showSliders },
    },
    [
      _vm.showSliders
        ? _c(
            "button",
            {
              staticClass: "button is-cancel is-slider",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.slideDates(true)
                },
              },
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["fas", "chevron-left"] },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dateRangeFilter" },
        [
          _c("dateRangePicker", {
            ref: "dateRangePicker",
            attrs: {
              ranges: _vm.ranges,
              "locale-data": _vm.localeData,
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate,
              linkedCalendars: true,
              alwaysShowCalendars: true,
              autoApply: true,
              "append-to-body": true,
              showDropdowns: false,
              opens: _vm.opens,
            },
            on: { update: _vm.onUpdate },
            scopedSlots: _vm._u([
              {
                key: "footer",
                fn: function () {
                  return [
                    _c("div", { staticClass: "drp-buttons" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-cancel",
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.resetDates.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("reset")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "button is-cancel ml-auto",
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.doCancel.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.dateRange,
              callback: function ($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSliders
        ? _c(
            "button",
            {
              staticClass: "button is-cancel is-slider",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.slideDates()
                },
              },
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["fas", "chevron-right"] },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }